import { loadMessages, locale } from 'devextreme/localization';
import i18next from 'i18next';

const loadedLanguages = [];

function buildMessages(language) {
  const t = i18next.getFixedT(language);

  return {
    Yes: t('common.yes'),
    No: t('common.no'),
    Cancel: t('common.cancel'),
    Clear: t('common.clear'),
    Done: t('common.done'),
    Loading: t('common.loading'),
    Select: t('common.select'),
    Search: t('common.search'),
    Back: t('common.back'),
    OK: t('common.ok'),
    'dxCollectionWidget-noDataText': t('devExtreme.dxCollectionWidget.noDataText'),
    'validation-required': t('devExtreme.validation.required'),
    'validation-required-formatted': t('devExtreme.validation.required', { context: 'formatted' }),
    'validation-numeric': t('devExtreme.validation.numeric'),
    'validation-numeric-formatted': t('devExtreme.validation.numeric', { context: 'formatted' }),
    'validation-range': t('devExtreme.validation.range'),
    'validation-range-formatted': t('devExtreme.validation.range', { context: 'formatted' }),
    'validation-stringLength': t('devExtreme.validation.stringLength'),
    'validation-stringLength-formatted': t('devExtreme.validation.stringLength', { context: 'formatted' }),
    'validation-custom': t('devExtreme.validation.custom'),
    'validation-custom-formatted': t('devExtreme.validation.custom', { context: 'formatted' }),
    'validation-compare': t('devExtreme.validation.compare'),
    'validation-compare-formatted': t('devExtreme.validation.compare', { context: 'formatted' }),
    'validation-pattern': t('devExtreme.validation.pattern'),
    'validation-pattern-formatted': t('devExtreme.validation.pattern', { context: 'formatted' }),
    'validation-email': t('devExtreme.validation.email'),
    'validation-email-formatted': t('devExtreme.validation.email', { context: 'formatted' }),
    'validation-mask': t('devExtreme.validation.mask'),
    'dxLookup-searchPlaceholder': t('devExtreme.dxLookup.searchPlaceholder'),
    'dxList-pullingDownText': t('devExtreme.dxList.pullingDownText'),
    'dxList-pulledDownText': t('devExtreme.dxList.pulledDownText'),
    'dxList-refreshingText': t('devExtreme.dxList.refreshingText'),
    'dxList-pageLoadingText': t('devExtreme.dxList.pageLoadingText'),
    'dxList-nextButtonText': t('devExtreme.dxList.nextButtonText'),
    'dxList-selectAll': t('devExtreme.dxList.selectAll'),
    'dxListEditDecorator-delete': t('devExtreme.dxListEditDecorator.delete'),
    'dxListEditDecorator-more': t('devExtreme.dxListEditDecorator.more'),
    'dxScrollView-pullingDownText': t('devExtreme.dxScrollView.pullingDownText'),
    'dxScrollView-pulledDownText': t('devExtreme.dxScrollView.pulledDownText'),
    'dxScrollView-refreshingText': t('devExtreme.dxScrollView.refreshingText'),
    'dxScrollView-reachBottomText': t('devExtreme.dxScrollView.reachBottomText'),
    'dxDateBox-simulatedDataPickerTitleTime': t('devExtreme.dxDateBox.simulatedDataPickerTitleTime'),
    'dxDateBox-simulatedDataPickerTitleDate': t('devExtreme.dxDateBox.simulatedDataPickerTitleDate'),
    'dxDateBox-simulatedDataPickerTitleDateTime': t('devExtreme.dxDateBox.simulatedDataPickerTitleDateTime'),
    'dxDateBox-validation-datetime': t('devExtreme.dxDateBox.validation.datetime'),
    'dxFileUploader-selectFile': t('devExtreme.dxFileUploader.selectFile'),
    'dxFileUploader-dropFile': t('devExtreme.dxFileUploader.dropFile'),
    'dxFileUploader-bytes': t('devExtreme.dxFileUploader.bytes'),
    'dxFileUploader-kb': t('devExtreme.dxFileUploader.kb'),
    'dxFileUploader-Mb': t('devExtreme.dxFileUploader.Mb'),
    'dxFileUploader-Gb': t('devExtreme.dxFileUploader.Gb'),
    'dxFileUploader-upload': t('devExtreme.dxFileUploader.upload'),
    'dxFileUploader-uploaded': t('devExtreme.dxFileUploader.uploaded'),
    'dxFileUploader-readyToUpload': t('devExtreme.dxFileUploader.readyToUpload'),
    'dxFileUploader-uploadFailedMessage': t('devExtreme.dxFileUploader.uploadFailedMessage'),
    'dxFileUploader-invalidFileExtension': t('devExtreme.dxFileUploader.invalidFileExtension'),
    'dxFileUploader-invalidMaxFileSize': t('devExtreme.dxFileUploader.invalidMaxFileSize'),
    'dxFileUploader-invalidMinFileSize': t('devExtreme.dxFileUploader.invalidMinFileSize'),
    'dxRangeSlider-ariaFrom': t('devExtreme.dxRangeSlider.ariaFrom'),
    'dxRangeSlider-ariaTill': t('devExtreme.dxRangeSlider.ariaTill'),
    'dxSwitch-switchedOnText': t('devExtreme.dxSwitch.switchedOnText'),
    'dxSwitch-switchedOffText': t('devExtreme.dxSwitch.switchedOffText'),
    'dxForm-optionalMark': t('devExtreme.dxForm.optionalMark'),
    'dxForm-requiredMessage': t('devExtreme.dxForm.requiredMessage'),
    'dxNumberBox-invalidValueMessage': t('devExtreme.dxNumberBox.invalidValueMessage'),
    'dxDataGrid-columnChooserTitle': t('devExtreme.dxDataGrid.columnChooserTitle'),
    'dxDataGrid-columnChooserEmptyText': t('devExtreme.dxDataGrid.columnChooserEmptyText'),
    'dxDataGrid-groupContinuesMessage': t('devExtreme.dxDataGrid.groupContinuesMessage'),
    'dxDataGrid-groupContinuedMessage': t('devExtreme.dxDataGrid.groupContinuedMessage'),
    'dxDataGrid-groupHeaderText': t('devExtreme.dxDataGrid.groupHeaderText'),
    'dxDataGrid-ungroupHeaderText': t('devExtreme.dxDataGrid.ungroupHeaderText'),
    'dxDataGrid-ungroupAllText': t('devExtreme.dxDataGrid.ungroupAllText'),
    'dxDataGrid-editingEditRow': t('devExtreme.dxDataGrid.editingEditRow'),
    'dxDataGrid-editingSaveRowChanges': t('devExtreme.dxDataGrid.editingSaveRowChanges'),
    'dxDataGrid-editingCancelRowChanges': t('devExtreme.dxDataGrid.editingCancelRowChanges'),
    'dxDataGrid-editingDeleteRow': t('devExtreme.dxDataGrid.editingDeleteRow'),
    'dxDataGrid-editingUndeleteRow': t('devExtreme.dxDataGrid.editingUndeleteRow'),
    'dxDataGrid-editingConfirmDeleteMessage': t('devExtreme.dxDataGrid.editingConfirmDeleteMessage'),
    'dxDataGrid-validationCancelChanges': t('devExtreme.dxDataGrid.validationCancelChanges'),
    'dxDataGrid-groupPanelEmptyText': t('devExtreme.dxDataGrid.groupPanelEmptyText'),
    'dxDataGrid-noDataText': t('devExtreme.dxDataGrid.noDataText'),
    'dxDataGrid-searchPanelPlaceholder': t('devExtreme.dxDataGrid.searchPanelPlaceholder'),
    'dxDataGrid-filterRowShowAllText': t('devExtreme.dxDataGrid.filterRowShowAllText'),
    'dxDataGrid-filterRowResetOperationText': t('devExtreme.dxDataGrid.filterRowResetOperationText'),
    'dxDataGrid-filterRowOperationEquals': t('devExtreme.dxDataGrid.filterRowOperationEquals'),
    'dxDataGrid-filterRowOperationNotEquals': t('devExtreme.dxDataGrid.filterRowOperationNotEquals'),
    'dxDataGrid-filterRowOperationLess': t('devExtreme.dxDataGrid.filterRowOperationLess'),
    'dxDataGrid-filterRowOperationLessOrEquals': t('devExtreme.dxDataGrid.filterRowOperationLessOrEquals'),
    'dxDataGrid-filterRowOperationGreater': t('devExtreme.dxDataGrid.filterRowOperationGreater'),
    'dxDataGrid-filterRowOperationGreaterOrEquals': t('devExtreme.dxDataGrid.filterRowOperationGreaterOrEquals'),
    'dxDataGrid-filterRowOperationStartsWith': t('devExtreme.dxDataGrid.filterRowOperationStartsWith'),
    'dxDataGrid-filterRowOperationContains': t('devExtreme.dxDataGrid.filterRowOperationContains'),
    'dxDataGrid-filterRowOperationNotContains': t('devExtreme.dxDataGrid.filterRowOperationNotContains'),
    'dxDataGrid-filterRowOperationEndsWith': t('devExtreme.dxDataGrid.filterRowOperationEndsWith'),
    'dxDataGrid-filterRowOperationBetween': t('devExtreme.dxDataGrid.filterRowOperationBetween'),
    'dxDataGrid-filterRowOperationBetweenStartText': t('devExtreme.dxDataGrid.filterRowOperationBetweenStartText'),
    'dxDataGrid-filterRowOperationBetweenEndText': t('devExtreme.dxDataGrid.filterRowOperationBetweenEndText'),
    'dxDataGrid-applyFilterText': t('devExtreme.dxDataGrid.applyFilterText'),
    'dxDataGrid-trueText': t('devExtreme.dxDataGrid.trueText'),
    'dxDataGrid-falseText': t('devExtreme.dxDataGrid.falseText'),
    'dxDataGrid-sortingAscendingText': t('devExtreme.dxDataGrid.sortingAscendingText'),
    'dxDataGrid-sortingDescendingText': t('devExtreme.dxDataGrid.sortingDescendingText'),
    'dxDataGrid-sortingClearText': t('devExtreme.dxDataGrid.sortingClearText'),
    'dxDataGrid-editingSaveAllChanges': t('devExtreme.dxDataGrid.editingSaveAllChanges'),
    'dxDataGrid-editingCancelAllChanges': t('devExtreme.dxDataGrid.editingCancelAllChanges'),
    'dxDataGrid-editingAddRow': t('devExtreme.dxDataGrid.editingAddRow'),
    'dxDataGrid-summaryMin': t('devExtreme.dxDataGrid.summaryMin'),
    'dxDataGrid-summaryMinOtherColumn': t('devExtreme.dxDataGrid.summaryMinOtherColumn'),
    'dxDataGrid-summaryMax': t('devExtreme.dxDataGrid.summaryMax'),
    'dxDataGrid-summaryMaxOtherColumn': t('devExtreme.dxDataGrid.summaryMaxOtherColumn'),
    'dxDataGrid-summaryAvg': t('devExtreme.dxDataGrid.summaryAvg'),
    'dxDataGrid-summaryAvgOtherColumn': t('devExtreme.dxDataGrid.summaryAvgOtherColumn'),
    'dxDataGrid-summarySum': t('devExtreme.dxDataGrid.summarySum'),
    'dxDataGrid-summarySumOtherColumn': t('devExtreme.dxDataGrid.summarySumOtherColumn'),
    'dxDataGrid-summaryCount': t('devExtreme.dxDataGrid.summaryCount'),
    'dxDataGrid-columnFixingFix': t('devExtreme.dxDataGrid.columnFixingFix'),
    'dxDataGrid-columnFixingUnfix': t('devExtreme.dxDataGrid.columnFixingUnfix'),
    'dxDataGrid-columnFixingLeftPosition': t('devExtreme.dxDataGrid.columnFixingLeftPosition'),
    'dxDataGrid-columnFixingRightPosition': t('devExtreme.dxDataGrid.columnFixingRightPosition'),
    'dxDataGrid-exportTo': t('devExtreme.dxDataGrid.exportTo'),
    'dxDataGrid-exportToExcel': t('devExtreme.dxDataGrid.exportToExcel'),
    'dxDataGrid-excelFormat': t('devExtreme.dxDataGrid.excelFormat'),
    'dxDataGrid-selectedRows': t('devExtreme.dxDataGrid.selectedRows'),
    'dxDataGrid-exportAll': t('devExtreme.dxDataGrid.exportAll'),
    'dxDataGrid-exportSelectedRows': t('devExtreme.dxDataGrid.exportSelectedRows'),
    'dxDataGrid-headerFilterEmptyValue': t('devExtreme.dxDataGrid.headerFilterEmptyValue'),
    'dxDataGrid-headerFilterOK': t('devExtreme.dxDataGrid.headerFilterOK'),
    'dxDataGrid-headerFilterCancel': t('devExtreme.dxDataGrid.headerFilterCancel'),
    'dxDataGrid-ariaColumn': t('devExtreme.dxDataGrid.ariaColumn'),
    'dxDataGrid-ariaValue': t('devExtreme.dxDataGrid.ariaValue'),
    'dxDataGrid-ariaFilterCell': t('devExtreme.dxDataGrid.ariaFilterCell'),
    'dxDataGrid-ariaCollapse': t('devExtreme.dxDataGrid.ariaCollapse'),
    'dxDataGrid-ariaExpand': t('devExtreme.dxDataGrid.ariaExpand'),
    'dxDataGrid-ariaDataGrid': t('devExtreme.dxDataGrid.ariaDataGrid'),
    'dxDataGrid-ariaSearchInGrid': t('devExtreme.dxDataGrid.ariaSearchInGrid'),
    'dxDataGrid-ariaSelectAll': t('devExtreme.dxDataGrid.ariaSelectAll'),
    'dxDataGrid-ariaSelectRow': t('devExtreme.dxDataGrid.ariaSelectRow'),
    'dxDataGrid-filterBuilderPopupTitle': t('devExtreme.dxDataGrid.filterBuilderPopupTitle'),
    'dxDataGrid-filterPanelCreateFilter': t('devExtreme.dxDataGrid.filterPanelCreateFilter'),
    'dxDataGrid-filterPanelClearFilter': t('devExtreme.dxDataGrid.filterPanelClearFilter'),
    'dxDataGrid-filterPanelFilterEnabledHint': t('devExtreme.dxDataGrid.filterPanelFilterEnabledHint'),
    'dxTreeList-ariaTreeList': t('devExtreme.dxTreeList.ariaTreeList'),
    'dxTreeList-editingAddRowToNode': t('devExtreme.dxTreeList.editingAddRowToNode'),
    'dxPager-infoText': t('devExtreme.dxPager.infoText'),
    'dxPager-pagesCountText': t('devExtreme.dxPager.pagesCountText'),
    'dxPivotGrid-grandTotal': t('devExtreme.dxPivotGrid.grandTotal'),
    'dxPivotGrid-total': t('devExtreme.dxPivotGrid.total'),
    'dxPivotGrid-fieldChooserTitle': t('devExtreme.dxPivotGrid.fieldChooserTitle'),
    'dxPivotGrid-showFieldChooser': t('devExtreme.dxPivotGrid.showFieldChooser'),
    'dxPivotGrid-expandAll': t('devExtreme.dxPivotGrid.expandAll'),
    'dxPivotGrid-collapseAll': t('devExtreme.dxPivotGrid.collapseAll'),
    'dxPivotGrid-sortColumnBySummary': t('devExtreme.dxPivotGrid.sortColumnBySummary'),
    'dxPivotGrid-sortRowBySummary': t('devExtreme.dxPivotGrid.sortRowBySummary'),
    'dxPivotGrid-removeAllSorting': t('devExtreme.dxPivotGrid.removeAllSorting'),
    'dxPivotGrid-dataNotAvailable': t('devExtreme.dxPivotGrid.dataNotAvailable'),
    'dxPivotGrid-rowFields': t('devExtreme.dxPivotGrid.rowFields'),
    'dxPivotGrid-columnFields': t('devExtreme.dxPivotGrid.columnFields'),
    'dxPivotGrid-dataFields': t('devExtreme.dxPivotGrid.dataFields'),
    'dxPivotGrid-filterFields': t('devExtreme.dxPivotGrid.filterFields'),
    'dxPivotGrid-allFields': t('devExtreme.dxPivotGrid.allFields'),
    'dxPivotGrid-columnFieldArea': t('devExtreme.dxPivotGrid.columnFieldArea'),
    'dxPivotGrid-dataFieldArea': t('devExtreme.dxPivotGrid.dataFieldArea'),
    'dxPivotGrid-rowFieldArea': t('devExtreme.dxPivotGrid.rowFieldArea'),
    'dxPivotGrid-filterFieldArea': t('devExtreme.dxPivotGrid.filterFieldArea'),
    'dxScheduler-editorLabelTitle': t('devExtreme.dxScheduler.editorLabelTitle'),
    'dxScheduler-editorLabelStartDate': t('devExtreme.dxScheduler.editorLabelStartDate'),
    'dxScheduler-editorLabelEndDate': t('devExtreme.dxScheduler.editorLabelEndDate'),
    'dxScheduler-editorLabelDescription': t('devExtreme.dxScheduler.editorLabelDescription'),
    'dxScheduler-editorLabelRecurrence': t('devExtreme.dxScheduler.editorLabelRecurrence'),
    'dxScheduler-openAppointment': t('devExtreme.dxScheduler.openAppointment'),
    'dxScheduler-recurrenceNever': t('devExtreme.dxScheduler.recurrenceNever'),
    'dxScheduler-recurrenceDaily': t('devExtreme.dxScheduler.recurrenceDaily'),
    'dxScheduler-recurrenceWeekly': t('devExtreme.dxScheduler.recurrenceWeekly'),
    'dxScheduler-recurrenceMonthly': t('devExtreme.dxScheduler.recurrenceMonthly'),
    'dxScheduler-recurrenceYearly': t('devExtreme.dxScheduler.recurrenceYearly'),
    'dxScheduler-recurrenceEvery': t('devExtreme.dxScheduler.recurrenceEvery'),
    'dxScheduler-recurrenceEnd': t('devExtreme.dxScheduler.recurrenceEnd'),
    'dxScheduler-recurrenceAfter': t('devExtreme.dxScheduler.recurrenceAfter'),
    'dxScheduler-recurrenceOn': t('devExtreme.dxScheduler.recurrenceOn'),
    'dxScheduler-recurrenceRepeatDaily': t('devExtreme.dxScheduler.recurrenceRepeatDaily'),
    'dxScheduler-recurrenceRepeatWeekly': t('devExtreme.dxScheduler.recurrenceRepeatWeekly'),
    'dxScheduler-recurrenceRepeatMonthly': t('devExtreme.dxScheduler.recurrenceRepeatMonthly'),
    'dxScheduler-recurrenceRepeatYearly': t('devExtreme.dxScheduler.recurrenceRepeatYearly'),
    'dxScheduler-switcherDay': t('devExtreme.dxScheduler.switcherDay'),
    'dxScheduler-switcherWeek': t('devExtreme.dxScheduler.switcherWeek'),
    'dxScheduler-switcherWorkWeek': t('devExtreme.dxScheduler.switcherWorkWeek'),
    'dxScheduler-switcherMonth': t('devExtreme.dxScheduler.switcherMonth'),
    'dxScheduler-switcherTimelineDay': t('devExtreme.dxScheduler.switcherTimelineDay'),
    'dxScheduler-switcherTimelineWeek': t('devExtreme.dxScheduler.switcherTimelineWeek'),
    'dxScheduler-switcherTimelineWorkWeek': t('devExtreme.dxScheduler.switcherTimelineWorkWeek'),
    'dxScheduler-switcherTimelineMonth': t('devExtreme.dxScheduler.switcherTimelineMonth'),
    'dxScheduler-switcherAgenda': t('devExtreme.dxScheduler.switcherAgenda'),
    'dxScheduler-recurrenceRepeatOnDate': t('devExtreme.dxScheduler.recurrenceRepeatOnDate'),
    'dxScheduler-recurrenceRepeatCount': t('devExtreme.dxScheduler.recurrenceRepeatCount'),
    'dxScheduler-allDay': t('devExtreme.dxScheduler.allDay'),
    'dxScheduler-confirmRecurrenceEditMessage': t('devExtreme.dxScheduler.confirmRecurrenceEditMessage'),
    'dxScheduler-confirmRecurrenceDeleteMessage': t('devExtreme.dxScheduler.confirmRecurrenceDeleteMessage'),
    'dxScheduler-confirmRecurrenceEditSeries': t('devExtreme.dxScheduler.confirmRecurrenceEditSeries'),
    'dxScheduler-confirmRecurrenceDeleteSeries': t('devExtreme.dxScheduler.confirmRecurrenceDeleteSeries'),
    'dxScheduler-confirmRecurrenceEditOccurrence': t('devExtreme.dxScheduler.confirmRecurrenceEditOccurrence'),
    'dxScheduler-confirmRecurrenceDeleteOccurrence': t('devExtreme.dxScheduler.confirmRecurrenceDeleteOccurrence'),
    'dxScheduler-noTimezoneTitle': t('devExtreme.dxScheduler.noTimezoneTitle'),
    'dxScheduler-moreAppointments': t('devExtreme.dxScheduler.moreAppointments'),
    'dxCalendar-todayButtonText': t('devExtreme.dxCalendar.todayButtonText'),
    'dxCalendar-ariaWidgetName': t('devExtreme.dxCalendar.ariaWidgetName'),
    'dxColorView-ariaRed': t('devExtreme.dxColorView.ariaRed'),
    'dxColorView-ariaGreen': t('devExtreme.dxColorView.ariaGreen'),
    'dxColorView-ariaBlue': t('devExtreme.dxColorView.ariaBlue'),
    'dxColorView-ariaAlpha': t('devExtreme.dxColorView.ariaAlpha'),
    'dxColorView-ariaHex': t('devExtreme.dxColorView.ariaHex'),
    'dxTagBox-selected': t('devExtreme.dxTagBox.selected'),
    'dxTagBox-allSelected': t('devExtreme.dxTagBox.allSelected'),
    'dxTagBox-moreSelected': t('devExtreme.dxTagBox.moreSelected'),
    'vizExport-printingButtonText': t('devExtreme.vizExport.printingButtonText'),
    'vizExport-titleMenuText': t('devExtreme.vizExport.titleMenuText'),
    'vizExport-exportButtonText': t('devExtreme.vizExport.exportButtonText'),
    'dxFilterBuilder-and': t('devExtreme.dxFilterBuilder.and'),
    'dxFilterBuilder-or': t('devExtreme.dxFilterBuilder.or'),
    'dxFilterBuilder-notAnd': t('devExtreme.dxFilterBuilder.notAnd'),
    'dxFilterBuilder-notOr': t('devExtreme.dxFilterBuilder.notOr'),
    'dxFilterBuilder-addCondition': t('devExtreme.dxFilterBuilder.addCondition'),
    'dxFilterBuilder-addGroup': t('devExtreme.dxFilterBuilder.addGroup'),
    'dxFilterBuilder-enterValueText': t('devExtreme.dxFilterBuilder.enterValueText'),
    'dxFilterBuilder-filterOperationEquals': t('devExtreme.dxFilterBuilder.filterOperationEquals'),
    'dxFilterBuilder-filterOperationNotEquals': t('devExtreme.dxFilterBuilder.filterOperationNotEquals'),
    'dxFilterBuilder-filterOperationLess': t('devExtreme.dxFilterBuilder.filterOperationLess'),
    'dxFilterBuilder-filterOperationLessOrEquals': t('devExtreme.dxFilterBuilder.filterOperationLessOrEquals'),
    'dxFilterBuilder-filterOperationGreater': t('devExtreme.dxFilterBuilder.filterOperationGreater'),
    'dxFilterBuilder-filterOperationGreaterOrEquals': t('devExtreme.dxFilterBuilder.filterOperationGreaterOrEquals'),
    'dxFilterBuilder-filterOperationStartsWith': t('devExtreme.dxFilterBuilder.filterOperationStartsWith'),
    'dxFilterBuilder-filterOperationContains': t('devExtreme.dxFilterBuilder.filterOperationContains'),
    'dxFilterBuilder-filterOperationNotContains': t('devExtreme.dxFilterBuilder.filterOperationNotContains'),
    'dxFilterBuilder-filterOperationEndsWith': t('devExtreme.dxFilterBuilder.filterOperationEndsWith'),
    'dxFilterBuilder-filterOperationIsBlank': t('devExtreme.dxFilterBuilder.filterOperationIsBlank'),
    'dxFilterBuilder-filterOperationIsNotBlank': t('devExtreme.dxFilterBuilder.filterOperationIsNotBlank'),
    'dxFilterBuilder-filterOperationBetween': t('devExtreme.dxFilterBuilder.filterOperationBetween'),
    'dxFilterBuilder-filterOperationAnyOf': t('devExtreme.dxFilterBuilder.filterOperationAnyOf'),
    'dxFilterBuilder-filterOperationNoneOf': t('devExtreme.dxFilterBuilder.filterOperationNoneOf'),
    'dxHtmlEditor-dialogColorCaption': t('devExtreme.dxHtmlEditor.dialogColorCaption'),
    'dxHtmlEditor-dialogBackgroundCaption': t('devExtreme.dxHtmlEditor.dialogBackgroundCaption'),
    'dxHtmlEditor-dialogLinkCaption': t('devExtreme.dxHtmlEditor.dialogLinkCaption'),
    'dxHtmlEditor-dialogLinkUrlField': t('devExtreme.dxHtmlEditor.dialogLinkUrlField'),
    'dxHtmlEditor-dialogLinkTextField': t('devExtreme.dxHtmlEditor.dialogLinkTextField'),
    'dxHtmlEditor-dialogLinkTargetField': t('devExtreme.dxHtmlEditor.dialogLinkTargetField'),
    'dxHtmlEditor-dialogImageCaption': t('devExtreme.dxHtmlEditor.dialogImageCaption'),
    'dxHtmlEditor-dialogImageUrlField': t('devExtreme.dxHtmlEditor.dialogImageUrlField'),
    'dxHtmlEditor-dialogImageAltField': t('devExtreme.dxHtmlEditor.dialogImageAltField'),
    'dxHtmlEditor-dialogImageWidthField': t('devExtreme.dxHtmlEditor.dialogImageWidthField'),
    'dxHtmlEditor-dialogImageHeightField': t('devExtreme.dxHtmlEditor.dialogImageHeightField'),
    'dxHtmlEditor-heading': t('devExtreme.dxHtmlEditor.heading'),
    'dxHtmlEditor-normalText': t('devExtreme.dxHtmlEditor.normalText'),
  };
}

// eslint-disable-next-line import/prefer-default-export
export function changeDxLocale(language) {
  if (!loadedLanguages.includes(language)) {
    const messages = buildMessages(language);
    loadMessages({ [language]: messages });
    loadedLanguages.push(language);
  }

  locale(language);
}
